import React from "react"
import classNames from "classnames"
import PropTypes from "prop-types"
import { useParams } from "react-router-dom"
import MetabaseChartMolecule from "views/molecules/canvases/charts/analytics/MetabaseChartMolecule"
import { getMetabaseAlias } from "services/compare/compareTypeService"

const CompareAssetsOrganism = ({ comparedNodes }) => {
  const { pillarId: urlPillarId } = useParams()

  const comparedNodesIds = comparedNodes.map((node) => node.id)
  const verdiktAlias = getMetabaseAlias(comparedNodes)

  return (
    <div className="Verdikt-Score">
      <div className={classNames(urlPillarId, "page-frame")}>
        <div className={classNames("page")}>
          <div
            className={classNames(
              urlPillarId,
              "widget",
              "chart",
              "transparent-widget"
            )}
          >
            <MetabaseChartMolecule
              verdikt_alias={verdiktAlias}
              compared_nodes_id={comparedNodesIds}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

CompareAssetsOrganism.propTypes = {
  comparedNodes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      has_websites_only: PropTypes.bool,
      has_infrastructure_equipment_only: PropTypes.bool,
      has_internal_infrastructure_equipment_only: PropTypes.bool,
    })
  ).isRequired,
}

export default CompareAssetsOrganism
